/// <amd-module name="Pipeline/Analytics/PipelineInsights/ControllerView/PipelineInsightsDialog" />
import * as React from "react";
import { VssComponent } from "VSS/Platform/Layout";
import { CornerDialog } from "VSSUI/Dialog";
import { Observer } from "VSSUI/Observer";
import { ObservableValue } from "VSS/Core/Observable";
import * as Resources from "Pipeline/Analytics/PipelineInsights/Resources";

export interface IPipelineInsightsDialogProps {
    insightsMessage: JSX.Element;
    cardTitle: string;
    onDismiss?: () => void;
    onViewReportClick?: () => void;
}

export class PipelineInsightsDialog extends VssComponent<IPipelineInsightsDialogProps> {
    private isDialogOpen = new ObservableValue<boolean>(true);

    public render() {
        return (
            <div>
                <Observer isDialogOpen={this.isDialogOpen}>
                    {(props: { isDialogOpen: boolean }) => {
                        return props.isDialogOpen ? (
                            <CornerDialog
                                onDismiss={this.props.onDismiss || this.onDismiss}
                                footerButtonProps={[
                                    {
                                        primary: true,
                                        text: Resources.ViewReportText,
                                        onClick: this.props.onViewReportClick
                                    }
                                ]}
                                titleProps={{
                                    text: this.props.cardTitle
                                }}
                            >
                                <div className="flex-column">
                                    <span className="body-m">{this.props.insightsMessage}</span>
                                </div>
                            </CornerDialog>
                        ) : null;
                    }}
                </Observer>
            </div>
        );
    }

    private onDismiss = () => {
        this.isDialogOpen.value = false;
    };
}
